import React from 'react';
import { FocusTrap } from 'focus-trap-react';

const FocusTrapWithVisibilityCheck = ({containerRef, isActive, children}) => {
  return (
    <FocusTrap
      active={isActive}
      focusTrapOptions={{
        checkCanFocusTrap: () => {
          return new Promise((resolve) => {
            const interval = setInterval(() => {
              if (containerRef.current && containerRef.current.checkVisibility()) {
                clearInterval(interval);
                resolve();
              }
            }, 1000);
          });
        }
      }}
    >
      {children}
    </FocusTrap>
  );
};

export default FocusTrapWithVisibilityCheck;